import Raven from 'raven-js';
import ActionType from './types';
import * as Constants from '../constants';
import {makeSignedRequest, getSignedRequest} from '../utils';
import axios from 'axios';
import qs from 'qs';
import store from '../store';
import { browserHistory } from 'react-router';
import cloneDeep from 'lodash/cloneDeep';
import { SubmissionError } from 'redux-form';

function logException(ex, context) {
  Raven.captureException(ex, {
    extra: context
  });
  /*eslint no-console:0*/
  window.console && console.error && console.error(ex);
}

function logFailure(message, context) {
  Raven.captureMessage(message, {
    extra: context
  });
  /*eslint no-console:0*/
  window.console && console.log && console.log(context);
}

export function getRequestToken() {

  const options = {oauth_callback: Constants.CALLBACK_URL};

  return (dispatch) => {
    getSignedRequest('POST', Constants.REQUEST_TOKEN_URL, options)
      .then((signedRequest) => {
        // by default the content-type of request is 'application/x-www-form-urlencoded'
        axios.post(Constants.REQUEST_TOKEN_URL, qs.stringify(signedRequest))
          .then((response) => {
            if (response.status === 200) {
              return qs.parse(response.data)
            } else {
              logFailure('Fetch Request Token Failed', response);
              throw new Error('Something went wrong')
            }
          })
          .then((body) => {
            const {oauth_callback_confirmed, oauth_token: oauthToken, oauth_token_secret: oauthTokenSecret} = body;
            if (oauth_callback_confirmed === "true") {
              dispatch({
                type: ActionType.STORE_REQUEST_TOKEN,
                oauthToken,
                oauthTokenSecret,
              })
            }
          })
          .then(() => window.location = `${Constants.AUTHORIZATION_URL}?oauth_token=${store.getState().user.oauthToken}`)
	      .catch(error => {
	    	  logException(error, {});
	      });
      });
  }
}

export function getAccessToken(oauth_verifier) {

  const options = {
    oauth_verifier: oauth_verifier,
    oauth_token: store.getState().user.oauthToken,
  };

  return (dispatch) => {
    getSignedRequest('POST', Constants.ACCESS_TOKEN_URL, options)
      .then((signedRequest) => {
        // by default the content-type of request is 'application/x-www-form-urlencoded'
        axios.post(Constants.ACCESS_TOKEN_URL, qs.stringify(signedRequest))
          .then((response) => {
            if (response.status === 200) {
              return qs.parse(response.data)
            } else {
              logFailure('Fetch Access Token Failed', response);
              throw new Error('Something went wrong')
            }
          })
          .then((body) => {
            const {oauth_token: oauthToken, oauth_token_secret: oauthTokenSecret, profileId} = body;

            // mark session user in FullStory
            //console.log('FS.identify(' + profileId + ')');
            //window.FS.identify(profileId, {});
            Raven.setUserContext({id: profileId});

            dispatch({
              type: ActionType.STORE_ACCESS_TOKEN,
              oauthToken,
              oauthTokenSecret,
              profileId,
            })
          })
          .then(() => browserHistory.push('/dashboard'))
	      .catch(error => {
	    	  logException(error, {});
	      });
      })
  }
}

export function setUserInfo() {
  return (dispatch) => {
    makeSignedRequest(Constants.USER_INFO_URL)
      .then(body => {
        dispatch({
          type: ActionType.SET_USER_INFO,
          ...body.response.profile
        })
      })
  }
}

export function setInfoForDashboard() {
  return (dispatch) => {
    dispatch(setCredentialsInfo())
      .then(() => {
        dispatch(setEvents());
        dispatch(setUpcomingEventsList());
        dispatch(clearEventDetails());
      })
  };
}

export function setCredentialsInfo() {
  return (dispatch) => (
    makeSignedRequest(Constants.GET_CREDENTIALS_URL)
      .then(body => {
        const {summary, assignedCredentials} = body;
        assignedCredentials.map((assignedCredential) => {
          if (assignedCredential.round === "") {
            assignedCredential.round = "manually-assigned-credentials"
          }
          return true;
        });
        dispatch({
          type: ActionType.SET_CREDENTIALS_INFO,
          summary,
          assignedCredentials
        })
      })
      .catch(error => {
    	  logException(error, {});
      })
  );
}

export function setEvents() {
  const eventsList = cloneDeep(Constants.ROUNDS);
  const {assignedCredentials} = store.getState().credentials;

  assignedCredentials.map(credential => {
    if (credential.credentialType !== "season") {
      let round = eventsList.filter((round) => round.id === credential.round)[0];
      round.passes[credential.credentialType] += 1;
    }
    return undefined
  });

  return {
    type: ActionType.SET_EVENTS,
    eventsList,
  }
}

export function setUpcomingEventsList() {
  const {eventsList} = store.getState().events;
  const upcomingEventsList = eventsList.filter((round) => {
    const [year, month, day] = round.end.split("-");
    const eventEndDate = new Date(year, month-1, day);
    const currentDate = new Date();
    return round.id === "manually-assigned-credentials" || eventEndDate.getTime() > currentDate.getTime()
  });

  return {
    type: ActionType.SET_UPCOMING_EVENTS,
    upcomingEventsList,
  }
}

export function setInfoForEventDetailsPage(eventId) {
  return (dispatch) => {
    dispatch(setCredentialsInfo())
      .then(() => {
        dispatch(setEventDetails(eventId))
      })
  };
}

export function setEventDetails(eventId) {
  const eventDetails = {id: eventId, assignedCredentials: []};
  const {assignedCredentials} = store.getState().credentials;
  const {name, schedule, trackName} = Constants.ROUNDS.filter((round) => round.id === eventId)[0];

  eventDetails.name = name;
  eventDetails.schedule = schedule;
  eventDetails.trackName = trackName;
  eventDetails.assignedCredentials = assignedCredentials.filter(({round}) => round === eventId);
  eventDetails.vipSingleCredentials = eventDetails.assignedCredentials.filter(({credentialType}) => credentialType === "hotpit_guest");
  eventDetails.workingSingleCredentials = eventDetails.assignedCredentials.filter(({credentialType}) => credentialType === "working_single");
  eventDetails.modelCredentials = eventDetails.assignedCredentials.filter(({credentialType}) => credentialType === "model");
  eventDetails.vipGuestCredentials = eventDetails.assignedCredentials.filter(({credentialType}) => credentialType === "guest");
  eventDetails.guestWristbandCredentials = eventDetails.assignedCredentials.filter(({credentialType}) => credentialType === "guest_wristband");
  eventDetails.paddockGuestWristbandCredentials = eventDetails.assignedCredentials.filter(({credentialType}) => credentialType === "paddock_guest_wristband");
  eventDetails.vendorGuestWristbandCredentials = eventDetails.assignedCredentials.filter(({credentialType}) => credentialType === "vendor_guest_wristband");
  eventDetails.broadcastGuestWristbandCredentials = eventDetails.assignedCredentials.filter(({credentialType}) => credentialType === "broadcast_guest_wristband");
  eventDetails.mediaSingleCredentials = eventDetails.assignedCredentials.filter(({credentialType}) => credentialType === "media_single");

  return {
    type: ActionType.SET_EVENT_DETAILS,
    eventDetails,
  }
}

export function clearEventDetails() {
  return {
    type: ActionType.CLEAR_EVENT_DETAILS,
  }
}

export function changeEventFilter(filter = 'upcoming') {
  return {
    type: ActionType.CHANGE_EVENT_FILTER,
    filter,
  }
}

export function changeEventDetailsFilter(filter = 'all') {
  return {
    type: ActionType.CHANGE_EVENT_DETAILS_FILTER,
    filter,
  }
}

export function submitRequestForm(values, reload=false) {
  return (dispatch) => (
    makeSignedRequest(Constants.REQUEST_CREDENTIAL, 'POST', values)
      .then(body => {
        if (body.error) {
          throw new SubmissionError({_error: body.message })
        } else {
          dispatch({
            type: ActionType.SUBMIT_REQUEST_FORM,
          })
        }
      })
      .then(() => reload ? window.location.reload() : browserHistory.goBack())
  );
}

export function updateCredential(credentialId, values, reload=false) {
  return (dispatch) => (
    makeSignedRequest(`${Constants.UPDATE_CREDENTIAL}/${credentialId}.json`, 'PUT', values)
      .then(body => {
        if (body.error) {
          throw new SubmissionError({_error: body.message })
        } else {
          dispatch({
            type: ActionType.UPDATE_CREDENTIAL,
          })
        }
      })
      .then(() => reload ? window.location = `/request-form-${values['credentialType'].replace('_', '-')}` : browserHistory.goBack())
  )
}

export function cancelCredential(credentialId) {
  return (dispatch) => {
    makeSignedRequest(`${Constants.CANCEL_CREDENTIAL}/${credentialId}.json`, 'DELETE')
      .then(body => {
        if (body.success) {
          dispatch({
            type: ActionType.CANCEL_CREDENTIAL,
          })
        }
      })
      .then(() => window.location.reload())
      .catch(error => {
    	  logException(error, {});
      })
  }
}

export function loadCredential(credentialId) {
  const { credentials: { assignedCredentials }} = store.getState();
  const [credentialToLoad] = assignedCredentials.filter(({credentialID}) => credentialID === credentialId);

  return {
    type: ActionType.LOAD_CREDENTIAL,
    credentialToLoad,
  };
}

export function logoutUser() {

  localStorage.clear();
  window.location = '/';

  return {
    type: ActionType.LOGOUT_USER,
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js